module.exports = __webpack_public_path__ + "media/images/top/etc-card-4-bed818cf3a2882cd9065e9730266eb10.jpg";